import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Avställda fordon ")
const _hoisted_2 = {
  class: "row",
  style: { fontSize: '14px' }
}
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  class: "col text-weight-bolder",
  style: { textAlign: 'right' }
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Orsak till ej tillgäng ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { square: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "text-h6 q-py-xs" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (table) => {
        return (_openBlock(), _createBlock(_component_q_table, {
          flat: "",
          rows: table.vehicles,
          columns: _ctx.columns,
          "hide-bottom": "",
          separator: "cell",
          "rows-per-page-options": [0],
          key: table.vehicle_type_description
        }, {
          header: _withCtx((props) => [
            _createVNode(_component_q_tr, {
              props: props,
              style: { textAlign: 'left' },
              class: "bg-grey-3 text-body1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_th, { style: {"width":"500px"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(table.vehicle_type_description), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(table.vehicle_type_available_count) + " / " + _toDisplayString(table.vehicle_type_withdrawn_count) + " (" + _toDisplayString(table.vehicle_type_total_count) + ") ", 1)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_th),
                _createVNode(_component_q_th, { style: { fontSize: '14px' } }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          body: _withCtx((props) => [
            _createVNode(_component_q_tr, {
              props: props,
              class: _normalizeClass(_ctx.$style.row)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_td, {
                  key: "vehicle_name",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.vehicle_name), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "withdrawn_place_name_short",
                  props: props,
                  style: {"width":"50px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.withdrawn_place_name_short), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "withdrawn_reason",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.withdrawn_reason), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 2
            }, 1032, ["props", "class"])
          ]),
          _: 2
        }, 1032, ["rows", "columns"]))
      }), 128))
    ]),
    _: 1
  }))
}